export { DegreeCardTiny, type DegreeCardTinyProps } from './DegreeCardTiny';
export {
  degreeCardTinyVariants,
  type DegreeCardTinyVariantProps,
} from './degree-card-tiny.variants';
